import React from 'react';
import { useFetchPoints } from '../../api/points';
import PointsMap from './PointsMap';

export default function PointsMapAsync() {
  const { data } = useFetchPoints();
  return <PointsMap data={{ markers: data }} />;
}
